import React from 'react';

import {withStyles} from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid/Grid";
import Colors from "../../template/Colors";

const style = theme => ({
    item: {
        paddingRight: '15px!important',
        paddingBottom: '5px!important',
    },
    itemTitle: {
        color: Colors.commons.gray7,
        fontSize: '12px',
        fontWeight: '400',
        lineHeight: '18px'
    },
    itemValue: {
        color: Colors.commons.gray7,
        borderBottom: `1px solid ${Colors.commons.gray6}`,
        fontWeight: '500',
        fontSize: '14px',
        height: '16px',
    }
});

const ItemGrid = (props) => {
    const {label, classes, size, children} = props;

    return  <Grid item xs={size} className={classes.item}>
                <div className={classes.itemTitle}>{label}</div>
                {children}
            </Grid>
};

export default withStyles(style)(ItemGrid);